/**
 * street-drama-audio.js
 * Mixin quản lý hệ thống âm thanh procedural SFX và Web Speech TTS cho StreetDramaDirector.
 */

import { SfxPlayer } from '../audio/sfx.js';

class AudioHolder {
  initAudioContext() {
    if (!this.sfx) {
      this.sfx = new SfxPlayer({
        isSoundEnabled: () => this.isSoundEnabled,
        onScreenShake: (intensity) => {
          this.screenShakeIntensity = intensity;
        }
      });
    } else {
      this.sfx.initAudioContext();
    }
    this.audioCtx = this.sfx.audioCtx;
  }

  resumeAudio() {
    if (this.sfx) this.sfx.resumeAudio();
  }

  // --- HỆ THỐNG ÂM THANH PROCEDURAL SFX (SfxPlayer) ---
  playWhoosh() {
    if (this.sfx) this.sfx.playWhoosh();
  }

  playPunchImpact() {
    if (this.sfx) this.sfx.playPunchImpact();
  }

  playBodyFall() {
    if (this.sfx) this.sfx.playBodyFall();
  }

  playCityHonk() {
    if (this.sfx) this.sfx.playCityHonk();
  }

  stopTts() {
    if (this.audioManager) {
      this.audioManager.stop();
    }
    this.lastSpokenKey = null;
  }

  speakTts(text, key, characterId = '') {
    if (!this.isTtsEnabled || !this.isPlaying) return;
    if (this.lastSpokenKey === key) return;
    this.lastSpokenKey = key;

    if (this.audioManager) {
      this.audioManager.setEnabled(this.isTtsEnabled);
      this.audioManager.playCue({
        cueId: key,
        text,
        characterId
      });
    }
  }
}

export function registerStreetDramaAudioMethods(proto) {
  Object.getOwnPropertyNames(AudioHolder.prototype).forEach((name) => {
    if (name !== 'constructor') {
      Object.defineProperty(proto, name, {
        value: AudioHolder.prototype[name],
        writable: true,
        configurable: true,
        enumerable: false
      });
    }
  });
}
